import { lazy } from 'react';

export const EventPage = lazy(() => import('./controller.js'));
